import { ColumnsFactory } from "../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {
  return [
    ColumnsFactory.TextColumn("Cod. Sg/Dn", "idDN"),
    ColumnsFactory.TextColumn("Sg/Dn","direccionNegocio"),
    ColumnsFactory.TextColumn("Cod. Área", "codArea"),
    ColumnsFactory.TextColumn("Área", "area")
  ];
};